/** @prettier */
import { useEffect, useState } from 'react';

import fetchService, { sanitizeErrorMessage } from '@xanadu/ui-shared/utils/fetchService';

/**
 * Requests and provides us content for the native app popup retrieved by dotCMS
 * @returns {Object} is the object representing the CMS content
 * @returns {Object.text} {String} The text shown in the popup
 * @returns {Object.backgroundImage} {String} The background image url
 * @returns {Object.phoneImage} {String} The phone image url
 */
export default function useCMSContent() {
  const [{ text, backgroundImage, phoneImage, error }, setData] = useState({
    error: '',
    text: '',
    backgroundImage: '',
    phoneImage: '',
  });

  const requestUrl = async () => {
    setData({ url: '', error: '', warningLevel: null });

    try {
      const response = await fetchService('/ui/api/v1/cms/content?contentType=NativeAppsPopup');
      const { contentlets = [], errors = [] } = response;

      if (errors.length) {
        setData((prevData) => ({
          ...prevData,
          error: sanitizeErrorMessage(errors),
        }));
        return;
      }

      if (contentlets[0]) {
        setData({
          error: '',
          text: contentlets[0].text,
          backgroundImage: contentlets[0].backgroundImage,
          phoneImage: contentlets[0].phoneImage,
        });
      }
    } catch (err) {
      const errorMessage = 'Error getting CMS content for native apps popup';
      setData((prevData) => ({ ...prevData, error: errorMessage }));

      // eslint-disable-next-line no-console
      console.warn(errorMessage, err);
    }
  };

  useEffect(() => {
    requestUrl();
  }, []);

  return { text, backgroundImage, phoneImage, error };
}
